<template>
  <ValidationProvider :rules="rules" :vid="prefixLabel + ' ' + label" immediate v-slot="{ failed }">
    <md-field :class="{ 'md-error': failed, 'md-form-group': icon, disabled }">
        <md-icon v-if="icon">{{ icon }}</md-icon>
        <label>
          {{ label }}
          <span v-if="required">&nbsp;*</span>
        </label>
        <md-select :value="value" v-on:input="$emit('input', $event)" type="text" :disabled="disabled" :readonly="readonly" :multiple="multiple" ref="md-select"  @blur = "onInputBlur()" :is_sortable="is_sortable">
          <template v-if="options">
            <md-option v-for="option of option_entries" :key="option[0]" :value="option[0]">{{ option[1] }}</md-option>
          </template>
          <template v-else>
            <slot></slot>
          </template>
        </md-select>
        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
    </md-field>
    <slot name="extraFields">
    </slot>
  </ValidationProvider>
  
  <!-- <p>Place holder</p> -->

  <!-- <div>
    <v-select
      :value="value"
      v-on:input="$emit('input', $event)"
      :items="items"
      :label="label"
    ></v-select>
  </div> -->
  
  <!-- <ValidationProvider :rules="rules" v-slot="{ failed }">
    <md-autocomplete :value="value" v-on:input="$emit('input', $event)" :md-options="option_values" autocomplete="url">
      <label>
        {{ label }}
        <span v-if="required">&nbsp;*</span>
      </label>
    </md-autocomplete>
  </ValidationProvider> -->
  
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    is_sortable: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: null,
      default: ""
    },
    options: [String, Array, Object],
    readonly: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false
    },
    defaultOption: {
      type: Boolean,
      default: false,
    },
    prefixLabel: {
      type: String,
      default: "",
    },
  },
  computed: {
    rules(){

      let rules = [];
      if(this.required) rules.push('required');

      return rules.join('|');
    },
    option_entries(){
      let optionValue = [];
      switch(typeof this.options){
        case 'string':
          optionValue = this.options.split(',').sort().map(i => [i,i]);
          break;
        case 'array':  return this.options.map(i => [i,i]);
        case 'object':
          if (this.options == null) {
            return {};
          } else {
            if (this.options instanceof Array) {
              if ( this.is_sortable ) {
                optionValue = Object.values(this.options).sort().map(i => [i, i]);
              } else {
                optionValue = Object.values(this.options).map(i => [i, i]);
              }
              break;
            } else {
              if ( this.is_sortable ) {
                optionValue = Object.entries(this.options).sort();
              } else {
                optionValue = Object.entries(this.options);
              }
              break;
            }
          }
        default: return [];
      }
      if (this.defaultOption) {
        //add all in first index of options
        optionValue.unshift(["All","All"]);
      }
      return optionValue;
    },
    option_values(){
      return this.option_entries.map(([k,v]) => v);
    },
    items(){
      switch(typeof this.options){
        case 'string': return this.options.split(',').map(i => {return {value: i, text: i};});
        case 'array':  return this.options.map(i => {return {value: i, text: i};});
        case 'object':
          if(this.options instanceof Array){
            return Object.values(this.options).sort().map(i => {return {value: i, text: i};});
          }else{
            return Object.entries(this.options).sort().map(([i,j]) => {return {value: j, text: i};});
          }
        default: return [];
      }
    },
  },
  watch: {
  },
  data() {
    return {data:'Weekly'};
  },
  methods : {
    onInputBlur(){
      let element = this.$refs["md-select"];
      element.showSelect = false;
    }
  },
};
</script>

<style lang="scss">
  .md-form-group .md-select-value{
    margin-left: 12px;
  }
  .disabled{
    opacity: 0.7;
  }
</style>
